'use strict';
import { module } from '../../app';
import * as commonConstants from '../../constants/constantStrings';

module.service('dateHelper', function () {

	this.defaultDateStrings = [
		commonConstants.DEFAULT_FOX_PRO_EMPTY_DATE,
		commonConstants.defaultDateTimeSqlMinValue,
		commonConstants.defaultDateTimeMinValue
	];

	this.isValidDateString = function (date) {
		return (new Date(date) !== "Invalid Date") && !isNaN(new Date(date));
	}

	this.isDateSet = function (dateString) {
		let isSet = dateString && this.defaultDateStrings.indexOf(dateString) === -1;

		if (isSet) {
			try {
				this.isValidDateString(dateString);
			}
			catch (error) {
				isSet = false;
			}
		}

		return isSet;
	};

});



// WEBPACK FOOTER //
// ./src/scripts/services/helpers/dateHelper.js